import { Card, CardContent } from "@mui/material";
import  { useState, useEffect } from "react";
import axiosServicesOnboarding from "../../../services/axiosServicesOnboarding";
import { Box, Typography } from "@mui/material";

const StepBox = ({ number, title }) => {
  return (
    <Box position="relative">
      <Box
        display="flex"
        alignItems="center"
        border="1px solid #e0e0e0"
        borderRadius="8px"
        padding="6px"
        bgcolor="#ffffff"
        position="relative"
      >
        {/* Number Circle */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="40px"
          height="40px"
          border="2px solid #001d7e"
          borderRadius="50%"
          marginRight="8px"
        >
          <Typography variant="body1" color="#001d7e" fontWeight="bold">
            {number}
          </Typography>
        </Box>

        {/* Title */}
        <Typography variant="body1" fontWeight="bold" color="#001d7e">
          {title}
        </Typography>

        {/* Pointed edge - border */}
        <Box
          position="absolute"
          right="-21px"
          top="50%"
          sx={{
            transform: "translateY(-50%)",
            borderLeft: "21px solid #e0e0e0",
            borderTop: "21px solid transparent",
            borderBottom: "21px solid transparent",
          }}
        />

        {/* Pointed edge - fill */}
        <Box
          position="absolute"
          right="-20px"
          top="50%"
          sx={{
            transform: "translateY(-50%)",
            borderLeft: "20px solid #ffffff",
            borderTop: "20px solid transparent",
            borderBottom: "20px solid transparent",
            zIndex: 1,
            height: "60px",
          }}
        />
      </Box>
    </Box>
  );
};

const FaceVerification = ({ onBack, refresh, setRefresh, data }) => {
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://dashboard.qoreid.com/qoreid-sdk/qoreid.js";
  //   script.async = true;

  //   document.body.appendChild(script);

  //   // Event listener for debugging button behavior
  //   script.onload = () => {
  //     console.log("QoreID script loaded");
  //     const qoreidButton = document.getElementById("QoreIDButton");
  //     if (qoreidButton) {
  //       // setup callbacks
  //       qoreidButton.addEventListener(
  //         "qoreid:verificationSubmitted",
  //         ({ detail }) => {
  //           console.log("submitted payload", detail);
  //           refreshData();
  //         }
  //       );
  //       qoreidButton.addEventListener(
  //         "qoreid:verificationError",
  //         ({ detail }) => {
  //           console.log("error payload", detail);
  //         }
  //       );
  //       qoreidButton.addEventListener(
  //         "qoreid:verificationClosed",
  //         ({ detail }) => {
  //           console.log("closed payload", detail);
  //           refreshData();
  //           // if (detail !== null) {
  //           //   refreshData();
  //           // }
  //         }
  //       );
  //     }
  //   };

  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_QOREID_SDK_URL || "https://dashboard.qoreid.com/qoreid-sdk/qoreid.js";
    script.async = true;

    const handleSubmitted = ({ detail }) => {
      console.log("submitted payload", detail);
      refreshData();
    };

    const handleError = ({ detail }) => {
      console.log("error payload", detail);
    };

    const handleClosed = ({ detail }) => {
      console.log("closed payload", detail);
      if (detail !== null) {
        refreshData();
      }
    };

    script.onload = () => {
      console.log("QoreID script loaded");
      
      // Retry mechanism to find the button
      const attachListeners = (attempts = 0) => {
        const qoreidButton = document.getElementById("QoreIDButton");
        
        if (qoreidButton) {
          console.log("QoreID button found, attaching listeners");
          
          // Remove any existing listeners first
          qoreidButton.removeEventListener("qoreid:verificationSubmitted", handleSubmitted);
          qoreidButton.removeEventListener("qoreid:verificationError", handleError);
          qoreidButton.removeEventListener("qoreid:verificationClosed", handleClosed);
          
          // Add new listeners
          qoreidButton.addEventListener("qoreid:verificationSubmitted", handleSubmitted);
          qoreidButton.addEventListener("qoreid:verificationError", handleError);
          qoreidButton.addEventListener("qoreid:verificationClosed", handleClosed);
        } else if (attempts < 10) {
          // Retry after 500ms if button not found yet
          console.log(`QoreID button not found, retrying... (${attempts + 1}/10)`);
          setTimeout(() => attachListeners(attempts + 1), 500);
        } else {
          console.error("QoreID button not found after 10 attempts");
        }
      };
      
      attachListeners();
    };

    document.body.appendChild(script);
    
    return () => {
      const qoreidButton = document.getElementById("QoreIDButton");
      if (qoreidButton) {
        qoreidButton.removeEventListener("qoreid:verificationSubmitted", handleSubmitted);
        qoreidButton.removeEventListener("qoreid:verificationError", handleError);
        qoreidButton.removeEventListener("qoreid:verificationClosed", handleClosed);
      }
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  async function refreshData() {
    console.log("refreshData called - Starting verify-face API call"); // Debugging log
    try {
      setLoading(true);
      console.log("Making POST request to Customer/verify-face");
      const res = await axiosServicesOnboarding.post("Customer/verify-face");
      console.log("verify-face API response:", res);
      setLoading(false);
      // setRefresh(!refresh);
      // onBack();
      window.location.reload();
    } catch (error) {
      console.error("verify-face API error:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      setLoading(false);
      alert("Verification failed. Please try again or contact support.");
    }
  }

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2 text-gray-700 text-lg font-semibold">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
              stroke="#0E156F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
              stroke="#0E156F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Face Verification</span>
        </div>
        <button onClick={onBack} className="text-gray-600 text-2xl">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0003 29.3337C23.3641 29.3337 29.3337 23.3641 29.3337 16.0003C29.3337 8.63653 23.3641 2.66699 16.0003 2.66699C8.63653 2.66699 2.66699 8.63653 2.66699 16.0003C2.66699 23.3641 8.63653 29.3337 16.0003 29.3337Z"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 12L12 20"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 12L20 20"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      <div className="px-8 py-2 bg-[#edf1f9] rounded-md mb-3">
        <Box maxWidth="600px" width="100%" p={2}>
          <StepBox number="02" title="Face Verification" />
        </Box>
      </div>
      <Card className="w-full md:w-[650px] mx-auto mt-[100px]">
        <CardContent className="p-6">
          <div className="space-y-4 flex flex-col items-center">
            <div
              dangerouslySetInnerHTML={{
                __html: `
                  <qoreid-button
                    id="QoreIDButton"
                    clientId="M2XORNWH0H25O4YY1377"
                    productCode="liveness_nin"
                    customerReference="fsdfsdf"
                    applicantData='${JSON.stringify({
                      firstname: data?.firstName,
                      lastname: data?.lastName,
                      phone: data?.phoneNumber ? `+${data.phoneNumber}` : "",
                      email: data?.emailAddress,
                    })}'
                  ></qoreid-button>
                `,
              }}
            />
          </div>

          <div className="flex justify-center mt-4">
            <button
              variant=""
              color=""
              onClick={refreshData}
              disabled={loading}
              className="bg-[#25233A] text-white py-2 px-4 rounded-md hover:bg-[#1a1b2e] disabled:opacity-50"
            >
              {loading ? "Processing..." : "I've Completed Verification"}
            </button>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default FaceVerification;
